<template>
    <nav class="bg-black w-screen z-50 relative overflow-hidden lg:overflow-visible">
        <div class="max-w-page mx-auto w-full">
            <div class="grid grid-cols-2 w-full lg:flex">
                <NuxtLink no-prefetch to="/leads" class="group h-16 lg:h-20 flex items-center px-4 cursor-pointer" @mouseover="$refs.lottie.play()">
                    <!-- <ClientOnly>
                        <Vue3Lottie
                            ref="lottie"
                            :animationData="ZapoLogoJson"
                            :height="30"
                            :width="30"
                            :playOnHover="false"
                            :autoPlay="false"
                            :loop="true"
                            :noMargin="true"
                            @onLoopComplete="$refs?.lottie?.stop()"
                        />
                    </ClientOnly>

                    <IconZapoLogoWhiteNoIcon class="h-[21px] order-1 mt-[7px] ml-1 fill-white" /> -->

                    <IconGetworkLogoWhite class='h-[21px]' />
                </NuxtLink>

                <!-- hidden lg:flex ml-8 h-20 overflow-visible flex items-center -->
                <TransitionHeight class="col-span-2 bg-black order-10 lg:order-2 lg:!h-20 relative !overflow-visible w-full" contentClass="lg:flex items-center lg:h-20 relative" :visable="open">

                    <template v-if='user.hasRole("zapo.director")'>
                        <DropdownBlack>
                            <template #button>Sales</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/sales/leads" class="nav-link" data-close v-text='"Leads"' />
                                <NuxtLink no-prefetch to="/sales/prospects/list" class="nav-link" data-close v-text='"Prospects"' />
                            </template>
                        </DropdownBlack>

                        <NuxtLink no-prefetch to="/onboarding" class="nav-link" data-close v-text='"Onboarding"' />

                        <NuxtLink no-prefetch to="/subscriptions" class="nav-link" v-text='"Subscriptions"' />

                        <!-- <DropdownBlack>
                            <template #button>Customers</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/subscriptions" class="nav-link" data-close v-text='"Subscriptions"' />
                                <NuxtLink no-prefetch to="/companies" class="nav-link" data-close v-text='"Companies"' />
                                <NuxtLink no-prefetch to="/users" class="nav-link" data-close v-text='"Users"' />
                            </template>
                        </DropdownBlack> -->

                        <DropdownBlack>
                            <template #button>Calendar</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Calendar"' />
                                <NuxtLink no-prefetch to="/events" class="nav-link" data-close v-text='"Events"' />
                                <NuxtLink no-prefetch to="/tasks" class="nav-link" data-close v-text='"Tasks"' />
                            </template>
                        </DropdownBlack>

                        <DropdownBlack>
                            <template #button>Reports</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/reports/lead-feed" class="nav-link" data-close v-text='"Lead feed"' />
                                <NuxtLink no-prefetch to="/reports/lead-volume" class="nav-link" data-close v-text='"Lead volume"' />
                                <NuxtLink no-prefetch to="/reports/cancellations" class="nav-link" data-close v-text='"Cancellations"' />
                                <NuxtLink no-prefetch to="/reports/calls" class="nav-link" data-close v-text='"Call monitoring"' />
                                <NuxtLink no-prefetch to="/reports/unknown-calls" class="nav-link" data-close v-text='"Unknown calls"' />
                                <NuxtLink no-prefetch to="/reports/commission" class="nav-link" data-close v-text='"Sales commission"' />
                                <NuxtLink no-prefetch to="/reports/sales-metrics" class="nav-link" data-close v-text='"Sales metrics"' />
                                <NuxtLink no-prefetch to="/reports/salesboard" class="nav-link" data-close v-text='"Sales board"' />
                                <NuxtLink no-prefetch to="/tasks" class="nav-link" data-close v-text='"Invoice forecasting"' />
                                <NuxtLink no-prefetch to="/reports/mrr" class="nav-link" data-close v-text='"MRR"' />
                            </template>
                        </DropdownBlack>

                        <DropdownBlack>
                            <template #button>Tools</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/tools/users" class="nav-link" data-close v-text='"Users"' />
                                <!-- <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Subscription management"' /> -->
                                <!-- <NuxtLink no-prefetch to="/tools/search-terms" class="nav-link" data-close v-text='"Search terms"' /> -->
                                <!-- <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Negative exclusions"' /> -->
                                <NuxtLink no-prefetch to="/tools/lead-quality-management" class="nav-link" data-close v-text='"Lead quality management"' />
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Call history"' />
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Unknown calls"' />
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Phone numbers"' />
                                <NuxtLink no-prefetch to="/tools/domains" class="nav-link" data-close v-text='"Domains"' />
                                <NuxtLink no-prefetch to="/tools/locations" class="nav-link" data-close v-text='"Locations"' />
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Campaign structures"' />
                                <NuxtLink no-prefetch to="/tools/system-options" class="nav-link" data-close v-text='"System options"' />
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Email templates"' />
                                <NuxtLink no-prefetch to="/tools/sms-templates" class="nav-link" data-close v-text='"SMS templates"' />
                            </template>
                        </DropdownBlack>
                    </template>

                    <template v-if='!user.hasRole("zapo.director") && user.hasRole("zapo.sales")'>
                        <NuxtLink no-prefetch to="/sales/leads" class="nav-link" data-close v-text='"Leads"' />
                        <NuxtLink no-prefetch to="/sales/prospects/list" class="nav-link" data-close v-text='"Prospects"' />
                        <NuxtLink no-prefetch to="/onboarding" class="nav-link" data-close v-text='"Onboarding"' />
                        <DropdownBlack>
                            <template #button>Calendar</template>
                            <template #menu>
                                <NuxtLink no-prefetch to="/calendar" class="nav-link" data-close v-text='"Calendar"' />
                                <NuxtLink no-prefetch to="/events" class="nav-link" data-close v-text='"Events"' />
                                <NuxtLink no-prefetch to="/tasks" class="nav-link" data-close v-text='"Tasks"' />
                            </template>
                        </DropdownBlack>
                    </template>


                    <div class="px-4 w-full lg:hidden">
                        <div class="border-b border-white/[0.15] w-full mt-2" />
                    </div>

                    <div class="py-2 lg:hidden">
                        <NuxtLink no-prefetch to="/leads" class="nav-link">
                            <IconUser class="w-6 h-6" />
                            <p class="pl-2 text-white">Profile</p>
                        </NuxtLink>

                        <button class="nav-link" @click="logout">
                            <IconLogOut class="w-6 h-6" />
                            <p class="pl-2 text-white">Logout</p>
                        </button>
                    </div>
                </TransitionHeight>

                <div class="flex items-center justify-end order-3 px-2 shrink-0 gap-2 lg:gap-0 relative">
                    <!-- <Toggle
                        class="mr-2"
                        :checked="isDark"
                        @toggle="
                            () => {
                                isDark = !isDark
                                setDark()
                            }
                        "
                    /> -->

                    <DropdownV2 :buttonCSS='"px-2 h-10"' :menuSpace='17' forceSide="right">
                        <template #button="{open}">
                            <IconUser class='w-6 h-6' :class='[open ? "stroke-white" : "stroke-grey-900"]' />
                        </template>

                        <template #menu>
                            <div class="table-multi-select-menu min-w-[240px] !pt-0">
                                <button @click='$authSanctum.viewAsRole("nick")' data-close>Reset</button>
                                <button @click='$authSanctum.viewAsRole("salesperson")' data-close>Sales</button>
                                <button @click='$authSanctum.viewAsRole("serviceperson")' data-close>Service</button>
                                <button @click='$authSanctum.viewAsRole("designperson")' data-close>Design</button>
                                <button @click='$authSanctum.viewAsRole("marketingperson")' data-close>Marketing</button>
                            </div>
                        </template>
                    </DropdownV2>

                    <Search />

                    <!-- <NuxtLink no-prefetch tag="button" to="/calls" class="w-10 h-10 flex items-center justify-center shrink-0">
                        <IconPhone class="h-[22px] w-[22px] stroke-grey-900" />
                    </NuxtLink> -->

                    <button id="nav-button" class="w-10 h-10 flex items-center justify-center lg:hidden shrink-0" @click="open = !open">
                        <IconMenu class="h-6 w-6 stroke-white" v-if="!open" />
                        <IconClose class="h-5 w-5 stroke-white" v-else />
                    </button>

                    <DropdownV2 class="hidden lg:block shrink-0" id="user-menu" forceSide="right">
                        <template #button="{ open }">
                            <div class="flex items-center border-l border-grey-500 border-opacity-20 shrink-0 ml-6 pl-6">
                                <p class="text-white text-15 font-semibold" v-if="user != null">{{ user.fullName() }}</p>
                                <IconArrowDown :class="{ 'rotate-180': open }" class="h-4.5 w-4.5 ml-3 transition-all stroke-white" />

                                <div class="ml-7 relative hidden w-12 h-12 bg-grey-300 rounded-tl-lg rounded-br-lg lg:flex items-center justify-center">
                                    <IconUser class="h-6 w-6 stroke-grey-700" />

                                    <div
                                        class="text-white bg-green-500 rounded-full h-5 text-center font-medium text-11 absolute top-0 right-[30px] leading-[20px]"
                                        :class="[user.notifications_unread >= 100 ? 'px-2' : 'w-5']"
                                        v-text="user.notifications_unread"
                                    />
                                </div>
                            </div>
                        </template>

                        <template #menu>
                            <div class="bg-black w-[398px] table-multi-select-menu !pb-2">
                                <NuxtLink no-prefetch tag="button" to="/notifications" data-close class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <IconBell class="w-6 h-6 stroke-grey-800" />
                                        <p class="text-white text-15 font-semibold pl-4">Notifications</p>
                                    </div>

                                    <IconArrowRight class="w-4.5 h-4.5 stroke-white" />
                                </NuxtLink>

                                <NuxtLink no-prefetch tag="button" to="/profile" data-close class="flex items-center justify-between">
                                    <div class="flex items-center">
                                        <IconUser class="w-6 h-6 stroke-grey-800" />
                                        <p class="text-white text-15 font-semibold pl-4">Profile</p>
                                    </div>

                                    <IconArrowRight class="w-4.5 h-4.5 stroke-white" />
                                </NuxtLink>

                                <button id="logout" @click="logout" data-close>
                                    <IconLogOut class="w-6 h-6 stroke-grey-800" />
                                    <p class="pl-4 text-white text-15 font-semibold">Logout</p>
                                </button>

                                <div class="px-4 mt-6" v-if='user.notifications.length > 0'>
                                    <div class="border-t border-white/20 flex items-center justify-between pt-4 pb-[14px]">
                                        <p class="font-semibold text-15">Notifications</p>

                                        <NuxtLink no-prefetch to="/notifications" v-text="'All notifications'" class="underline text-white text-12" data-close />
                                    </div>

                                    <div v-for="(notification, ni) in user.notifications" :key="ni" class="flex py-4 border-t border-white/20">
                                        <component :is="notification.data.icon" class="shrink-0 w-4.5 h-4.5 mt-0.5" :class="notification.data.classes.icon" />

                                        <div class="w-full pl-2.5 text-white">
                                            <p class="text-15 font-semibold">{{ notification.data.title }}</p>
                                            <p class="text-13 text-grey-700">{{ notification.data.description }}</p>
                                            <div class="flex items-center justify-between pt-2">
                                                <NuxtLink no-prefetch class="underline text-12" v-for="(link, text) in notification.data.links" :key="text" :to="link" v-text="text" data-close />

                                                <p class="text-12 text-grey-800">{{ $moment(notification.created_at).format('HH:mm') }}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <!-- <NuxtLink no-prefetch to="/notifications" data-close class="!h-14 !px-6 !text-14 text-white bg-white-t-15 text-left -mx-2 flex items-center !w-auto">
                                    <p>See all notifications</p>
                                </NuxtLink> -->
                            </div>
                        </template>
                    </DropdownV2>
                </div>
            </div>
        </div>
    </nav>
</template>

<script>
import User from '~/models/user.js'
import Search from '~/components/customer/navs/components/search.vue'
import ZapoLogoJson from '~/assets/animation-zapo-logo.json'
import DropdownBlack from '~/components/customer/input/dropdown-black.vue'

export default {
    data() {
        return {
            open: false,
            isDark: false,
            viewNav: 'main',
            ZapoLogoJson,
        }
    },

    created() {
        
        this.setDark()
    },

    methods: {
        async logout() {
            await this.$authSanctum.logout()
        },

        setDark() {
            if (this.isDark) {
                document.documentElement.classList.add('dark')
            } else {
                document.documentElement.classList.remove('dark')
            }
        },
    },

    computed: {
        user() {
            return this.$authSanctum.getUser()
        },
    },

    components: {
        Search: Search,
        DropdownBlack
    },
}
</script>
